import { render, staticRenderFns } from "./NewModule.vue?vue&type=template&id=0fc9027e&"
import script from "./NewModule.vue?vue&type=script&lang=js&"
export * from "./NewModule.vue?vue&type=script&lang=js&"
import style0 from "./NewModule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports